'use strict';
import appConfigModule from '../../appConfig/appConfig.module';
import { Injectable, Inject } from 'ng-metadata/core';
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";
import { STATE_NAMES } from '../../primoExplore/primoExploreStates.module';
import {getInstitutionCode} from '../../appConfig/appConfigForward';


@Injectable()
export class OrgListCategorizeService {
	public ORG_LIST_DELIMITER = "───";

	private restIlsUrl: string;
	private breadcrumbs:Object;
	private test:Object;
	private iscategories;
	private _isMobileDBSlider = false;
	
	constructor(@Inject('$http') private $http: ng.IHttpService,
				@Inject('restBaseURLs') restBaseURLs,
				private configurationUtil: ConfigurationUtil,
				@Inject('$state') private $state: angular.ui.IStateService,
				@Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService){
	    this.$http = $http;
	    this.restIlsUrl = restBaseURLs.orgListEsploroUrl;
	}

	public isOrgListSearch() {
		return  this.$state.current.name === STATE_NAMES.ORGANIZATION_LIST;
	}
	
	public isSearchFromOrgListCategory () {
        if (this.isOrgListSearch()) {
            if (this.$stateParams['organization'])
                return true;
            else {
                return false;
            }
        }

        else {
            return false;
        }
    }

	public getOrgListCategories() {
		return this.$http.get(this.restIlsUrl + '?institution=' + getInstitutionCode() );
	}
	
	public setCategories(iscategories){
		this.iscategories=iscategories;
	}
	
	public isCategories(){
		return this.iscategories;
	}

	public getCategory(item) : any{
        if(item){
            if(item.dbcategories){
                if (this.configurationUtil.getBackendSystem() === 'suprima') {
                    return item.dbcategories[0]? item.dbcategories[0].dbcategory : [];
                }else{
                    return item.dbcategories.dbcategory;
                }
            }else{
                return item.dbcategory;
            }
        }else{
            console.log("ERROR: Item is not defined.")
            return null;
        }

    }

    public setCategory(item, category){
        if (item.dbcategory) {
            item.dbcategory = category;
        }
        else {
            if (this.configurationUtil.getBackendSystem() === 'suprima') {
            	item.dbcategories= [{dbcategory: category}];
        	}
        	else{
                item.dbcategories.dbcategory = category;
			}
        }
	}

	get isMobileDBSlider () {
		return this._isMobileDBSlider;
	}

	set isMobileDBSlider (isMobileDBSlider) {
		this._isMobileDBSlider = isMobileDBSlider;
	}

	public get RESEARCH_SLOT_TAB():string {return 'Research'; }

	public get ORGANIZATION_SEARCH_TYPE():string {return 'organization'; }


}


// WEBPACK FOOTER //
// ./src/main/webapp/components/journals/orgListCategorize/orgListCategorize.service.ts